export enum Role {
    SysAdmin = 'SysAdmin',
}

export type DbRole = 'full-admin';
